import styled from 'styled-components';

import { Dropdown } from '@dreryk/react-components';

import { StyledVisitLocationAddress } from './VisitLocationAddress.styled';

export const StyledVisitLocationDropdownItem = styled(Dropdown.Item)`
   transition: inherit;

   &:hover ${StyledVisitLocationAddress} {
      color: inherit;
   }
`;
